import React from 'react'
import './footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <a href="true" className='footer__logo'>Webvolutionize</a>

      <ul className='permalinks'>
        <li><a href="#header">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      
      <div className="footer__copyright">
        <small>Copyright &copy; {currentYear} Webvolutionize. All Rights Reserved</small>
      </div>

    </footer>
  )
}

export default Footer